/**
 * DRR-065 Metadata Manifest Types
 * Auto-generated from graphql_gateway/src/metadata_manifest/repository.rs
 * DO NOT EDIT MANUALLY - Run ./frontend/scripts/sync-backend-metadata.sh
 */

export interface PrimitiveMetadata {
  name: string;
  symbol: string;
  graphql_query: string;
  graphql_mutation_prefix: string;
  phase: string;
  fields: string[];
  registry_version: number;
  description?: string;
  life_critical?: boolean;
  metadata?: string;
}

export interface EntityTypeMetadata {
  name: string;
  code: string;
  graphql_query: string;
  safety_level: 'CRITICAL' | 'HIGH' | 'MEDIUM' | 'LOW';
  fields: string[];
  graphql_type_name: string;
  description?: string;
  metadata?: string;
}

export interface SubgraphMetadata {
  name: string;
  number: number;
  entity_types: EntityTypeMetadata[];
  description?: string;
}

export interface FormPatternMetadata {
  name: string;
  layout_type: string;
  description?: string;
}

export interface MetadataManifest {
  manifest_version: string;
  primitives: PrimitiveMetadata[];
  subgraphs: SubgraphMetadata[];
  form_patterns: FormPatternMetadata[];
  generated_at: string;
}

export type AvailableSubgraph = 'fhir' | 'payroll' | 'erp';
export type AvailablePrimitive =
  | 'Workflow' | 'Template' | 'Dependency' | 'Policy' | 'Role'
  | 'Team' | 'Actor' | 'Validation' | 'Contract' | 'Constraint'
  | 'Instance' | 'Task' | 'Approval' | 'Document' | 'Queue'
  | 'Event' | 'Notification' | 'Trace' | 'Checkpoint' | 'Transaction'
  | 'Audit' | 'Analytics' | 'Schedule' | 'Resource' | 'Integration';

/**
 * Type-safe metadata manifest
 * This should be populated from GraphQL query: metadataManifest
 */
export const METADATA_MANIFEST: MetadataManifest = {
  manifest_version: '1.0',
  primitives: [],
  subgraphs: [],
  form_patterns: [],
  generated_at: new Date().toISOString()
};
